import { render, staticRenderFns } from "./B2Bpages.vue?vue&type=template&id=9036e58e&scoped=true"
import script from "./B2Bpages.vue?vue&type=script&lang=js"
export * from "./B2Bpages.vue?vue&type=script&lang=js"
import style0 from "./B2Bpages.vue?vue&type=style&index=0&id=9036e58e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9036e58e",
  null
  
)

export default component.exports